






















import { Component, Mixins } from "vue-property-decorator";
import { default as TexturePattern } from "./TexturePattern.vue";
import { ShapeDrawableMixin } from "./mixins";

@Component({
  components: {
    TexturePattern,
  },
})
export default class CircleDrawer extends Mixins(ShapeDrawableMixin) {
  toRadius(value: number): number {
    return (value < 0)
      ? 0
      : value;
  }
}
